export const PERIOD_FILTER_DEFAULT_VALUE = 0;
